import Content from "../common/Content";
import Footer from "../common/Footer";
import Header from "../common/Header";
import { API } from "../../helper/Api";
import { useLocation, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { RotatingLines } from "react-loader-spinner";
import SessionHandler from "../common/SessionHandler"; // Import the session handler
import RichTextEditor from "../common/RichTextEditor";
import { useRole } from "../contextApi/RoleContext";
import Multiselect from "multiselect-react-dropdown";
import ImageUpload from "../common/ImageUpload";
import ErrorPopup from "../common/ErrorPopup";
import Select from "react-select"; // Import React Select
import makeAnimated from 'react-select/animated';

export default function AddNewCatalog() {
  const animatedComponents = makeAnimated();
const { setRole, role, setPermission, permission, setUserDetails,userDetails} =
    useRole();
    
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const API_URL = process.env.REACT_APP_BASE_URL;
  const upc = queryParams.get('upc');

  // Basic Information
  const [type, setType] = useState("SingleItem");
  const [productCode, setProductCode] = useState("");
  const [storedescription, setStoreDescription] = useState("");
  const [clu, setClu] = useState("");
  const [casePack, setCasePack] = useState(0);
  const [orderByCase, setOrderByCase] = useState(false);
  // const [upc, setUPC] = useState("");

  // Classification
  const [alldcsss ,setalldcsss] = useState([]);
  const [dcss ,setdcss] = useState();
  const [deptCode, setDeptCode] = useState("");
  const [deptDescription, setDeptDescription] = useState("");
  // const [deparments, setDeparments] = useState([]);
  const [deptClassCode, setClassCode] = useState("");
  const [classDescription, setClassDescription] = useState("");
  // const [classes, setClasses] = useState([]);

  //Price Level
  const [priceLevels, setPriceLevels] = useState([]);
  const [prices, setPrices] = useState([]);
  const [basePrice, setBasePrice] = useState(0);

  //Vendor Information
  const [primaryvendor, setPrimaryVendor] = useState("");
  const [secondaryvendor, setSecondaryVendor] = useState("");
  const [allvendors, setAllVendors] = useState([]);
  const [primaryVlu, setPrimaryVlu] = useState("");
  const [primaryminQty, setPrimaryMinQty] = useState(0);
  const [primaryorderCost, setPrimaryOrderCost] = useState(0);
  const [secondaryVlu, setSecondaryVlu] = useState("");
  const [secondaryminQty, setSecondaryMinQty] = useState(0);
  const [secondaryorderCost, setSecondaryOrderCost] = useState(0);
  // const [primaryVendor, setPrimaryVendor] = useState("");

  // Custom Data
  const [webDescription, setWebDescription] = useState("");
  const [reason, setReason] = useState("");
  // const [franchiseGroupCode, setFranchiseGroupCode] = useState("");
  const [webShortDescription, setWebShortDescription] = useState("");
  const [webLongDescription, setWebLongDescription] = useState("");
  const [metawords, setMetawords] = useState("");
  const [batteries, setBatteries] = useState(false);
  const [chokingHazard, setChokingHazard] = useState(false);
  const [nso, setNso] = useState(false);
  const [leExclusive, setLEExclusive] = useState(false);
  const [extraShippingCharge, setExtraShippingCharge] = useState(false);
  const [giftWrap, setGiftWrap] = useState(false);
  const [ageAppropriateness, setAgeAppropriateness] = useState("");
  const [batteryType, setBatteryType] = useState("");
  const [gender, setGender] = useState("");
  const [lowAge, setLowAge] = useState("");
  const [highAge, setHighAge] = useState("");
  const [shippingType, setShippingType] = useState("");
  const [leItemCategory, setLEItemCategory] = useState("");
  const [leCurrentCatalog, setLECurrentCatalog] = useState([]);
  const [status, setStatus] = useState("Pending Review");
  const [individualAges, setIndividualAges] = useState([]);
  const [individualAgesString, setIndividualAgesString] = useState("");
  const [interests, setInterests] = useState([]);
  const [interests1, setInterests1] = useState("");
  const [skillBuilder, setSkillBuilder] = useState([]);
  const [skillBuilder1, setSkillBuilder1] = useState("");
  const [leCatalogDesignation, setLECatalogDesignation] = useState([]);
  const [leCatalogDesignation1, setLECatalogDesignation1] = useState([]);
  const [trendCategory, setTrendCategory] = useState("");
  const [taxCategoryOptions, setTaxCategoryOptions] = useState([{label:"Standard Retail",value:1},{label:"Non-taxable",value:2},{label:"Apparel",value:3},{label:"Food",value:4}]);

  const [taxCategory, setTaxCategory] = useState("1");

  const numbers = [0, 0.5, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];


  const [image1, setImage1] = useState(null);
  const [image2, setImage2] = useState(null);
  const [image3, setImage3] = useState(null);
  const [videoUrl,setVideoUrl]=useState("");
  const [availableOnWeb,setAvailableOnWeb] = useState(false);
   const [storeCode, setStoreCode] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  ////validation 
  const [errors, setErrors] = useState({
    Type: '',
    CLU: '',
    Product_Description: '',
    UPC: '',
    DCSS: '',
    PrimaryVendor: '',
    PrimaryOrderCost: '',
    PrimaryMinOrderQty: '',
    PrimaryVLU: '',
    BasePrice:'',
    TaxCategory:''
  });

  const toggleModal = () => {
    setShowModal(!showModal);
  };

  const selectType = (e) => {
    setType(e.target.value);
  };
  // const selectDept = (e) => {
  //   setDept(e.target.value);
  // };
  // const selectClass = (e) => {
  //   setClass(e.target.value);
  // };
  const selectPrimaryVendor = (e) => {
    setPrimaryVendor(e.target.value);
  };
  const selectSecondaryVendor = (e) => {
    setSecondaryVendor(e.target.value);
  };

  const setWebDescriptionContent = (e) => {
    setWebDescription(e);
  };

  const setWebShortDescriptionContent = (e) => {
    setWebShortDescription(e);
  };
  const setWebLongDescriptionContent = (e) => {
    setWebLongDescription(e);
  };

   ///get the store code /////
   const fetchStoreCode = async () => {
    try {
      const res = await fetch(`${API_URL}location.php`);
      // Check if the response is successful (status 200)
      if (!res.ok) {
        throw new Error("Network response was not ok");
      }
      const result = await res.json();
      console.log(result)
      const extractCode = result.ApiDocument.Response.Locations.map(
        (item) => {
          return { code: item.Code,name: item.Name };
        }
      ).filter((item) => item.code);
     // console.log("test",extractCode)
      setStoreCode(extractCode);
      // if(userDetails.usertype !=="CORP"){
      //   const filterCodeBasedOnUser= extractCode.filter(item => userDetails.storecode.some(its=> its.storecode === item.code));
      //   setStoreCode(filterCodeBasedOnUser);
      //   console.log("filtered code",filterCodeBasedOnUser)
      // }else{
      //   setStoreCode(extractCode);
      // }
      
      
      // console.log("store code", extractCode);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  //////////////////////////////

  useEffect(() => {
    console.log("test",userDetails)
    if(userDetails.usertype.trim() !=="CORP"){
setStatus('Pending Review');
    }

    fetchStoreCode();
    getvendors();
    // getdeparments();
    // getclasses();
   
    getAllDCSS();
  }, []);

  useEffect(()=>{
    getAllpriceLevels();
  },[storeCode])

  const getAllDCSS = () => {
    API.getDcsss()
      .then((data) => {
        setalldcsss(data);
      })
      .catch((err) => console.log(err));
  };

  const selectDcss = (e) =>{
    setdcss(e.target.value);
    API.getSecificDcsss(e.target.value)
    .then((data) => {
      if(data.dept_description){
        if(data.dept_description == "FOOD"){
        const taxOption = taxCategoryOptions.find((item,index) => 
           { return item.label.toLowerCase() == data.dept_description.toLowerCase() }
        )
        setTaxCategory(taxOption.value);
      }else{
        const taxOption = taxCategoryOptions.find((item,index) => 
          { return item.label == "Standard Retail" }
       )
       setTaxCategory(taxOption.value);       
      }

      }
      setDeptCode(data.dept_code);
      setDeptDescription(data.dept_description);
      setClassCode(data.class_code);
      setClassDescription(data.class_description);
    })
    .catch((err) => console.log(err));
  }

  // const getdeparments = () => {
  //   API.getDeparments()
  //     .then((datas) => {
  //       const deparments = datas.ApiDocument.Response.InvenDepartments.flatMap(
  //         (deparments) => deparments
  //       );
  //       setDeparments(deparments);
  //     })
  //     .catch((err) => console.log(err));
  // };


  // const getclasses = () => {
  //   API.getClasses()
  //     .then((datas) => {
  //       const classes = datas.ApiDocument.Response.InvenClasses.flatMap(
  //         (classes) => classes
  //       );
  //       setClasses(classes);
  //     })
  //     .catch((err) => console.log(err));
  // };

  const getAllpriceLevels = () => {
    API.getPriceLevels()
      .then((datas) => {
        const Allpricelevels = datas.ApiDocument.Response.PriceLevels.flatMap(
          (Allpricelevels) => Allpricelevels
        );

        const pricelevels = Allpricelevels.filter(
          (item) => item.Code !== "BASEPRICE" && item.Code !== ""
        );
        const getUpdatedPrice =pricelevels
        .map((item)=>{
          let matchedStoreCode = storeCode.find(it=> it.code === item.Code)
          if(matchedStoreCode){
            return {...item,value: "",strname:matchedStoreCode.name}
          }else{
            return {...item,value: "",strname:''}
          }
            
        })
        const sortedData = getUpdatedPrice.sort((a, b) => {
          if (a.strname.toLowerCase() < b.strname.toLowerCase()) {
            return -1;
          }
          if (a.strname.toLowerCase() > b.strname.toLowerCase()) {
            return 1;
          }
          return 0;
        });
        console.log("find",getUpdatedPrice);
        setPriceLevels(getUpdatedPrice);
      })
      .catch((err) => console.log(err));
  };

  const getvendors = () => {
    API.getVendors()
      .then((datas) => {
        const Allvendors = datas.ApiDocument.Response.Vendors.flatMap(
          (Allvendors) => Allvendors
        );
        setAllVendors(Allvendors);
      })
      .catch((err) => console.log(err));
  };

  const navigate = useNavigate();


  const addCallBack = (result) => {
    if (result) {
      toast.success("Added Catalog", {
        position: "top-center",
        autoClose: false,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "colored",
      });
      setTimeout(() => {
        navigate("/add-new-catalog");
      }, 3000);
    }
  };

  const handleChange = (e, inputId) => {
    const value = e.target.value;
   // console.log("priceCheck",prices);
   if(inputId ==="440" && userDetails.usertype.trim() !=="CORP"){
setBasePrice(value);
   }
    setPriceLevels(prev =>{
      const updatePrice = prev.map((item)=>{
       return item.Code === inputId ? {...item,value:value} : item
      })
      return updatePrice
    })
    

    // setPrices((prevPrices) => ({
    //   ...prevPrices,
    //   [inputId]: value,
    // }));
    // console.log("finalPriceLevel",priceLevels);
  };
  useEffect(()=>{
    const setUpdatedPrice =priceLevels.map((item)=>{
      return {[item.Code]: item.value}
     })
     console.log("finalOp",setUpdatedPrice);
     setPrices(setUpdatedPrice);
  },[priceLevels])

  const handleSetBasePrice =(e)=>{
    //console.log(e.target.value);
    setBasePrice(e.target.value)
    setPriceLevels(prev=>{
      const setBasicPrice= prev.map((item)=>{
        return {...item,value:e.target.value}
      }) 
     return setBasicPrice;
    })
  }

  //set individual ages based on low and high age value
  useEffect(()=>{
    if(!highAge && !lowAge){
      setIndividualAgesString("");
    setIndividualAges([]);
    return;
    };
    const lowAges= parseFloat(lowAge)
    const highAges= parseFloat(highAge)
    let result1="";
    let result2="";
    if(lowAges && highAges){
      result1 = numbers.filter(num => num >= lowAges && num <= highAges).map(item =>({ ages:item}));
    result2 = numbers.filter(num => num >= lowAges && num <= highAges);
    
    }else if(lowAges && !highAges){
      result1 = numbers.filter(num => num >= lowAges).map(item =>({ ages:item}));
      result2 = numbers.filter(num => num >= lowAges);
    }else if(!lowAges && highAges){
      result1 = numbers.filter(num =>  num <= highAges).map(item =>({ ages:item}));
      result2 = numbers.filter(num => num <= highAges);
    }
    const commaSeparatedValues = result2.join(',');
    setIndividualAgesString(commaSeparatedValues);
    setIndividualAges(result1)
 
  },[highAge,lowAge])

  ///make the skill builder option as comma separated string format
const handleSkillBuilders=(val)=>{
 
  const makeSkillString = val.map(item=> item.value).join(',');
  setSkillBuilder(val);
  setSkillBuilder1(makeSkillString);
  console.log("skill",makeSkillString);
  
}

  /////end////
  ///make the designation s comma separted string format

const handleDesignation=(val)=>{
  const makeDesignationString = val.map(item=> item.ID).join(',');
  setLECatalogDesignation(val)
  setLECatalogDesignation1(makeDesignationString)
  console.log(makeDesignationString);
}


  ////end//////////////

  ///captalize the option ///

  const capitalizeWords = (str) => {
    return str
      .split(' ') 
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize each word
      .join(' '); 
  };
  


  //////end/////////////////

  //handle item interest ////
const handleItemInterest=(val)=>{
  const makeItemInterestString = val.map(item=> item.value).join(',');
  setInterests(val)
  setInterests1(makeItemInterestString)
  console.log(makeItemInterestString);
  
}



  /////end///////////
  const closePopup = () => {
    setShowPopup(false);
  };

  useEffect(()=>{
    if(!batteryType){
      setBatteries(false);
    }else{
      setBatteries(true);
    }
  },[batteryType])


  const newCatalog = async(e) => {
    e.preventDefault();

    //validate the required fields here///
    setErrors([])
  
    let isValid = true;

    if(!type){
      isValid = false;
      setErrors((prev)=>({...prev, DCSS:"DCSS field is required"}))
    }
    if(!clu){
      isValid = false;
      setErrors((prev)=>({...prev, CLU:"CLU field is required"}))
    }
    if(!storedescription){
      isValid = false;
      setErrors((prev)=>({...prev, ProductDescription:"Product Description field is required"}))
    }
    if(!upc){
      isValid = false;
      setErrors((prev)=>({...prev, UPC:"UPC field is required"}))
    }
    if(!dcss){
      isValid = false;
      setErrors((prev)=>({...prev, DCSS:"DCSS field is required"}))
    }
    if(!primaryvendor){
      isValid = false;
      setErrors((prev)=>({...prev, PrimaryVendor:"Primary Vendor field is required"}))
    }
    if(!primaryorderCost){
      isValid = false;
      setErrors((prev)=>({...prev, PrimaryOrderCost:"Primary Order Cost field is required"}))
    }
    if(!primaryminQty){
      isValid = false;
      setErrors((prev)=>({...prev, PrimaryMinOrderQty:"Primary Min Order Qty field is required"}))
    }
    if(!basePrice){
      isValid = false;
      setErrors((prev)=>({...prev, BasePrice:"Base Price field is required"}))
    }
    if(!taxCategory){
      isValid = false;
      setErrors((prev)=>({...prev, TaxCategory:"Tax Category field is required"}))
    }
    if(!primaryVlu){
      isValid = false;
      setErrors((prev)=>({...prev, PrimaryVLU:"Primary VLU field is required"}))
    }

    if(!isValid){
     setShowPopup(true);
    }else{
      try{
        const res =await API.addCatalog({
          type,
          storedescription,
          clu,
          casePack,
          orderByCase,
          upc,
          deptCode,
          deptClassCode,
          prices,
          basePrice,
          primaryvendor,
          primaryVlu,
          primaryminQty,
          primaryorderCost,
          secondaryvendor,
          secondaryVlu,
          secondaryminQty,
          secondaryorderCost,
          webDescription,
          reason,
          webShortDescription,
          webLongDescription,
          metawords,
          batteries,
          chokingHazard,
          nso,
          leExclusive,
          extraShippingCharge,
          giftWrap,
          ageAppropriateness,
          batteryType,
          gender,
          lowAge,
          highAge,
          shippingType,
          leItemCategory,
          leCurrentCatalog,
          status,
          individualAgesString,
          interests1,
          skillBuilder1,
          leCatalogDesignation1,
          trendCategory,
          taxCategory,
          availableOnWeb,
        });
        if(res.Message ==="The request is invalid."){
          toast.error("Something went wrong. Please try again.", {
              position: "top-center",
              autoClose: false,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              theme: "colored",
            });
            console.log("check form status",res.Message);
        }
        else if(res.Status ==="InProcess"){
          toast.success("Added Catalog", {
            position: "top-center",
            autoClose: false,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            theme: "colored",
            onClose: () => {
              navigate("/catalog-list");  
            },
          });
        }
        
          }catch(err){
            console.error("Error",err);
          }
        
    }
    
    







    /////end////////////////////////////
   
    

      ////handle image and video upload here///
// if(image1 || image2 || image3 || videoUrl){
//   console.log("tesete")
//   const formData = new FormData();
//         formData.append("image1", image1);
//         formData.append("image2", image2);
//         formData.append("image3", image3);
//         formData.append("video", videoUrl);
//         formData.append("cluid", clu);
//         try {
//           const response = await fetch(`${API_URL}CatalogImages.php`, {
//             method: "POST",
//             body: formData,
//           });
//           if (!response.ok) {
//             throw new Error("Network response was not ok");
//           }
//           const result = await response.json();
         
//         } catch (error) {
//           console.error("Error:", error);
//         }
// }


  /////end////////
 
    // toast.success("Added Catalog", {
    //   position: "top-center",
    //   autoClose: false,
    //   hideProgressBar: false,
    //   closeOnClick: true,
    //   pauseOnHover: true,
    //   draggable: true,
    //   theme: "colored",
    // });
    
  };

console.log(errors)

  return (
    <>
      <ToastContainer
        position="top-center"
        autoClose={500}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
{showPopup && <ErrorPopup errors={errors} onClose={closePopup} />}


      <div class="container-fluid page-body-wrapper">
        <div class="main-panel">
          <div class="content-wrapper">
           
            {/* <form class="item-form">
              <div class="card">
                <h2>Basic Information</h2>
                <div class="form-item-row">
                  <div class="input-group">
                    <label>
                      TYPE<span class="required">*</span>
                    </label>
                    <select
                      class="form-control"
                      id="type"
                      onChange={selectType}
                    >
                      <option value="SingleItem">Single</option>
                      <option value="Style">Style</option>
                    </select>
                  </div>
                  <div class="input-group">
                    <label>
                      PRODUCT CODE<span class="required">*</span>
                    </label>
                    <input
                      type="text"
                      required
                      placeholder="Enter code"
                      onChange={(e) => setProductCode(e.target.value)}
                    />
                  </div>
                  <div class="input-group">
                    <label>
                      PRIMARY VENDOR<span class="required">*</span>
                    </label>
                    <input
                      type="text"
                      id="primary_vendor"
                      placeholder="Enter Primary Vendor"
                      onChange={(e) => setPrimaryVendor(e.target.value)}
                    />
                  </div>
                </div>
                <div class="form-item-row">
                  <div class="input-group full-width">
                    <label>
                      DESCRIPTION<span class="required">*</span>
                    </label>
                    <input
                      type="text"
                      id="description"
                      placeholder="Enter Description"
                      onChange={(e) => setDescription(e.target.value)}
                    />
                  </div>
                </div>
                <div class="form-item-row">
                  <div class="input-group">
                    <label>
                      BASE PRICE<span class="required">*</span>
                    </label>
                    <input
                      type="text"
                      id="baseprice"
                      placeholder="0.00"
                      onChange={(e) => setBasePrice(e.target.value)}
                    />
                  </div>
                  <div class="input-group">
                    <label>
                      CLU<span class="required">*</span>
                    </label>
                    <input
                      type="text"
                      id="clu"
                      placeholder="Enter CLU"
                      onChange={(e) => setClu(e.target.value)}
                    />
                  </div>
                  <div class="input-group">
                    <label>UPC(NC)</label>
                    <input
                      type="text"
                      id="upc"
                      placeholder="Enter UPC"
                      onChange={(e) => setUPC(e.target.value)}
                    />
                  </div>
                </div>
              </div>

              <div class="card">
                <h2>Classification</h2>
                <div class="form-item-row">
                  <div class="input-group">
                    <label>
                      DEPARTMENT<span class="required">*</span>
                    </label>
                    <select
                      class="form-control"
                      id="store"
                      onChange={selectDept}
                    >
                      <option value="">Select Department</option>
                      <option value="001">ARTS & CRAFTS</option>
                      <option value="002">BOOKS</option>
                      <option value="004">ACTIVE PLAY & SKILL TOYS</option>
                      <option value="006">GAMES & PUZZLES</option>
                      <option value="007">DOLLS</option>
                      <option value="009">CONSTRUCTION & BUILDING</option>
                      <option value="011">IMPULSE</option>
                      <option value="012">PLUSH</option>
                      <option value="013">IMAGINATIVE & PRETEND PLAY</option>
                      <option value="014">SCIENCE</option>
                      <option value="015">TRANSIT</option>
                      <option value="017">TRADING CARDS</option>
                      <option value="018">FASHION</option>
                      <option value="019">DEVELOPMENTAL & EDUCATIONAL</option>
                      <option value="021">FOOD</option>
                      <option value="029">SERVICES</option>
                      <option value="030">SUPPLIES</option>
                      <option value="999">NEON ELEPHANT</option>
                    </select>
                  </div>
                  <div class="input-group">
                    <label>
                      CLASS<span class="required">*</span>
                    </label>
                    <select
                      class="form-control"
                      id="selectDeptClassCode"
                      onChange={selectClass}
                    >
                      <option value="">Select Department</option>
                      <option value="001">ACTIVITY KITS</option>
                      <option value="002">ART SUPPLIES</option>
                      <option value="003">FASHION & JEWELRY KITS</option>
                      <option value="021">ACTIVITY BOOKS</option>
                      <option value="022">BOARD & CLOTH BOOKS</option>
                      <option value="023">CHAPTER & SERIES BOOKS</option>
                      <option value="024">LEARN TO READ BOOKS</option>
                      <option value="025">WORKBOOKS</option>
                      <option value="026">HARDCOVER</option>
                      <option value="027">PAPERBACK</option>
                      <option value="028">BABY & INDESTRUCTIBLES</option>
                      <option value="041">BUBBLES & CHALK</option>
                      <option value="042">INDOOR PLAY</option>
                      <option value="043">LAWN & GARDEN</option>
                      <option value="044">OUTDOOR PLAY</option>
                      <option value="045">POOL, WATER & SAND</option>
                      <option value="046">RIDE-ONS</option>
                      <option value="047">SKILL TOYS</option>
                      <option value="048">SPORTS</option>
                      <option value="061">BRAINTEASERS</option>
                      <option value="062">CARD GAMES</option>
                      <option value="063">ELECTRONIC </option>
                      <option value="064">FAMILY GAMES </option>
                      <option value="065">PUZZLES </option>
                      <option value="066">TABLETOP GAMES </option>
                      <option value="067">HANDHELD GAMES </option>
                      <option value="261">LEARNING AIDS </option>
                      <option value="081">BABY DOLLS & ACCESSORIES</option>
                      <option value="082">COLLECTIBLES</option>
                      <option value="083">FASHION DOLLS & ACCESSORIES</option>
                      <option value="084">
                        DOLL HOUSES, PLAYSETS & ACCESSORIES
                      </option>
                      <option value="101">INTERLOCKING</option>
                      <option value="102">MAGNETIC</option>
                      <option value="103">MARBLE RUNS</option>
                      <option value="121">BIN ITEMS</option>
                      <option value="082">COLLECTIBLES</option>
                      <option value="122">FIDGETS</option>
                      <option value="123">GREETING CARDS</option>
                      <option value="124">HEALTH & SAFETY</option>
                      <option value="125">STICKERS</option>
                      <option value="082">COLLECTIBLES</option>
                    </select>
                  </div>
                  <div class="input-group">
                    <label>
                      TAX GROUP CODE<span class="required">*</span>
                    </label>
                    <input
                      type="text"
                      id="taxgroupcode"
                      placeholder="Enter Tax Group Code"
                      onChange={(e) => setTaxGroupCode(e.target.value)}
                    />
                  </div>
                </div>
                <div class="form-item-row">
                  <div class="input-group">
                    <label>SUB CLASS 1(NC) </label>
                    <input
                      type="text"
                      placeholder="Enter SUB Class 1"
                      onChange={(e) => setSubClass1(e.target.value)}
                    />
                  </div>
                </div>
                <div class="form-item-row">
                  <div class="input-group">
                    <label>SUB CLASS 2(NC)</label>
                    <input
                      type="text"
                      placeholder="Enter SUB Class 1"
                      onChange={(e) => setSubClass2(e.target.value)}
                    />
                  </div>

                </div>
              </div>

              <div class="card">
                <h2>Vendor Information</h2>
                <div class="form-item-row">
                  <div class="input-group">
                    <label>VLU(NC)</label>
                    <input
                      type="text"
                      placeholder="Enter VLU"
                      onChange={(e) => setVlu(e.target.value)}
                    />
                  </div>
                  <div class="input-group">
                    <label>MIN.QTY</label>
                    <input
                      type="number"
                      placeholder="0"
                      onChange={(e) => setMinQty(e.target.value)}
                    />
                  </div>
                  <div class="input-group">
                    <label>ORDER COST</label>
                    <input
                      type="number"
                      step="0.01"
                      placeholder="0.00"
                      onChange={(e) => setOrderCost(e.target.value)}
                    />
                  </div>
                </div>
              </div>

              <div class="card">
                <h2>Attribute Information</h2>
                <div class="form-item-row">
                  <div class="input-group">
                    <label>ATTRIBUTE 1(NC)</label>
                    <input
                      type="text"
                      placeholder="Enter Attribute 1"
                      onChange={(e) => setAttribute1(e.target.value)}
                    />
                  </div>
                  <div class="input-group">
                    <label>ATTRIBUTE 2(NC)</label>
                    <input
                      type="text"
                      placeholder="Enter Attribute 2"
                      onChange={(e) => setAttribute2(e.target.value)}
                    />
                  </div>
                  <div class="input-group">
                    <label>ATTRIBUTE 3(NC)</label>
                    <input
                      type="text"
                      placeholder="Enter Attribute 3"
                      onChange={(e) => setAttribute3(e.target.value)}
                    />
                  </div>
                </div>
                <div class="form-item-row">
                  <div class="input-group">
                    <label>ATTRIBUTE SET 1(NC)</label>
                    <input
                      type="text"
                      placeholder="Enter Attribute Set 1	"
                      onChange={(e) => setAttributeSet1(e.target.value)}
                    />
                  </div>
                  <div class="input-group">
                    <label>ATTRIBUTE SET 2(NC)</label>
                    <input
                      type="text"
                      placeholder="Enter Attribute Set 2"
                      onChange={(e) => setAttributeSet2(e.target.value)}
                    />
                  </div>
                  <div class="input-group">
                    <label>ATTRIBUTE SET 3(NC)</label>
                    <input
                      type="text"
                      placeholder="Enter Attribute Set 3"
                      onChange={(e) => setAttributeSet3(e.target.value)}
                    />
                  </div>
                </div>
              </div>

              <button type="submit" className="submit-btn" onClick={newCatalog}>
                Save Item
              </button>
            </form> */}
            <div class="header">
              <div>
                <h1>Item Master</h1>
                <p>Manage your inventory items</p>
              </div>
              <div class="btn-group">
                {/* <button class="btn btn-outline">Clear Form</button> */}
                <button class="btn btn-primary" onClick={newCatalog}>
                  SAVE CHANGES
                </button>
              </div>
            </div>

            <form>
              <div class="section section-blue">
                <h2>BASIC INFO</h2>
                <div class="grid grid-3">
                  <div class="form-group">
                    <label class="required">Type</label>
                    <select
                      class="form-control"
                      id="type"
                      onChange={selectType}
                    >
                      <option value="SingleItem">Single</option>
                      <option value="Style">Style</option>
                    </select>
                  </div>
                  {/* <div class="form-group">
                    <label class="required">Product Code</label>
                    <input
                      type="text"
                      placeholder="Enter code"
                      onChange={(e) => setProductCode(e.target.value)}
                    />
                  </div> */}
                  {/* <div class="form-group">
                        <label>Status</label>
                        <select>
                            <option value="active">Active</option>
                            <option value="inactive">Inactive</option>
                        </select>
                    </div> */}
                  <div class="form-group">
                    <label class="required">CLU</label>
                    <input type="text" class="form-control" id="clu" onChange={(e) => setClu(e.target.value)} required="required" />
                  </div>

                  <div class="form-group">
                    <label class="required">Product Description</label>
                    <input type="text" class="form-control" id="description" onChange={(e) => setStoreDescription(e.target.value)} required />
                  </div>
                  <div class="form-group">
                    <label class="required">UPC</label>
                    <input type="text" id="upc" placeholder="Enter UPC" value={upc} />{" "}
                  </div>
                  <div class="form-group" style={{marginTop:"6px"}}>
                    <label>Case Pack</label>
                    <input type="text" id="upc" placeholder="Enter Pack"  onChange={(e)=>setCasePack(e.target.value)} />
                  </div>

                  <div class="form-group" style={{marginTop:"6px"}}>
                    <label>Order By Case</label>
                    <div className="orderbycase_checkbox">
                      <label className={`switch3 ${orderByCase ? "switch3-checked" : ""}`} >
                        <input   type="checkbox" checked={orderByCase} onChange={(e) => setOrderByCase(e.target.checked)}  />
                        <div></div>
                      </label>
                    </div>
                  </div>

                  <div class="form-group">
                    <label className="deparmentlabel required">DCSS</label>
                    <select class="form-control" id="store" onChange={(e) =>selectDcss(e)} required>
                      <option value="">Select Department</option>

                      {alldcsss.map((alldcss, index) => (
  <option value={alldcss.dcss}>
    {capitalizeWords(`${alldcss.dept_description} - ${alldcss.class_description}`)}
  </option>
))}

                    </select>
                  </div>

                  <div class="form-group" style={{marginTop:"6px"}}>
                    <label className="deparmentlabel">Department</label>
                    <input type="text" value={capitalizeWords(deptDescription)}/>
                    {/* <select
                      class="form-control"
                      id="store"
                      onChange={selectDept}
                    >
                      <option value="">Select Department</option>

                      {deparments.map((deparment, index) => (
                        <option value={deparment.Code}>{deparment.Name}</option>
                      ))}
                    </select> */}
                  </div>
                  <div class="form-group">
                    <label className="classlabel" style={{marginTop:"6px"}}>Class</label>
                    <input type="text" value={capitalizeWords(classDescription)} />
                    {/* <select
                      class="form-control"
                      id="store"
                      onChange={selectClass}
                    >
                      <option value="">Select Class</option>
                      {classes.map((classe, index) => (
                        <option value={classe.Code}>{classe.Name}</option>
                      ))}
                    </select> */}
                  </div>

                  {/* <div class="form-group">
                        <label>Base Price</label>
                        <input type="text" class="form-control" id="baseprice" placeholder="" onChange={(e)=>setBasePrice(e.target.value)}/>
                        </div> */}
                  {/* <div class="form-group">
                        <label>Model</label>
                        <input type="text" />
                    </div>
                    <div class="form-group">
                        <label>UPC</label>
                        <input type="text" />
                    </div>
                    <div class="form-group">
                        <label>SKU</label>
                        <input type="text" />
                    </div> */}
                </div>
              </div>

              <div class="section section-green">
                <h2>VENDOR INFO</h2>
                <div class="grid grid-4">
                  <div class="form-group">
                    <label class="required">Primary Vendor</label>
                    <select class="form-control" id="store" onChange={selectPrimaryVendor} required>
                      <option value="">Select Vendor</option>
                      {allvendors.map((vendor, index) => (
                        <option value={vendor.VendorCode}>
                          {capitalizeWords(vendor.Name)} (#{vendor.VendorCode})
                        </option>
                      ))}
                    </select>
                  </div>
                  <div class="form-group">
                    <label class="required">Primary Order Cost </label>
                    <input type="number" onChange={(e) => setPrimaryOrderCost(e.target.value)} required  />
                  </div>
                  <div class="form-group">
                    <label class="required">Primary Min Order Qty</label>
                    <input type="number" placeholder="0" onChange={(e) => setPrimaryMinQty(e.target.value)} required />
                  </div>
                  <div class="form-group">
                    <label class="required">Primary VLU</label>
                    <input type="text" placeholder="Enter VLU" onChange={(e) => setPrimaryVlu(e.target.value)} />
                  </div>
                </div>

                <div class="grid grid-4">
                  <div class="form-group">
                    <label>Secondary Vendor</label>
                    <select
                      class="form-control"
                      id="store"
                      onChange={selectSecondaryVendor}
                    >
                      <option value="">Select Vendor</option>
                      {allvendors.map((vendor, index) => (
                        <option value={vendor.VendorCode}>
                          {capitalizeWords(vendor.Name)} (#{vendor.VendorCode})
                        </option>
                      ))}
                    </select>
                  </div>
                  <div class="form-group">
                    <label>Secondary Order Cost </label>
                    <input
                      type="number"
                      onChange={(e) => setSecondaryOrderCost(e.target.value)}
                    />
                  </div>
                  <div class="form-group">
                    <label>Secondary Min Order Qty</label>
                    <input
                      type="number"
                      placeholder="0"
                      onChange={(e) => setSecondaryMinQty(e.target.value)}
                    />
                  </div>
                  <div class="form-group">
                    <label>Secondary VLU</label>
                    <input
                      type="text"
                      placeholder="Enter VLU"
                      onChange={(e) => setSecondaryVlu(e.target.value)}
                    />
                  </div>
                </div>
              </div>


         {userDetails.usertype.trim() ==="CORP" ? (
          <div class="section section-gray">
                <h2 className="pricelevel_title">Price Level</h2>
                <div class="grid grid-3">
                  <div class="form-group">
                    <div>
                      {/* Modal */}
                      <div
                        className={`modal fade ${showModal ? "show" : ""}`}
                        tabIndex="-1"
                        style={{ display: showModal ? "block" : "none" }}
                        aria-hidden={!showModal}
                      >
                        <div className="modal-dialog modal-lg">
                          {" "}
                          {/* Add modal-lg class here for large modal */}
                          <div className="modal-content">
                            {/* Modal Header */}
                            <div className="modal-header">
                              <h5 className="modal-title">
                                All Store Price Level
                              </h5>
                              <button
                                type="button"
                                className="close"
                                onClick={toggleModal}
                              >
                                <span aria-hidden="true">&times;</span>
                              </button>
                            </div>

                            {/* Modal Body */}
                            <div className="modal-body">
                              <div class="grid grid-4">
                                {priceLevels.map((priceLevel, index) => (
                                  <div class="form-group">
                                    <label>{priceLevel.strname} (#{priceLevel.Description})</label>
                                    <input
                                      type="number"
                                      className="priceLevel"
                                      id={priceLevel.Code}
                                      value={priceLevel.value}
                                      onChange={(e) =>
                                        handleChange(e, priceLevel.Code)
                                      }
                                    />
                                  </div>
                                ))}
                              </div>
                            </div>

                            {/* Modal Footer */}
                            <div className="modal-footer">
                              {/* <button type="button" className="btn btn-secondary" onClick={toggleModal}>
                Close
              </button> */}
                              {/* <button type="button" className="btn btn-primary" onClick={toggleModal}>
                Save changes
              </button> */}
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Optional: Overlay for modal */}
                      {showModal && (
                        <div className="modal-backdrop fade show" />
                      )}
                    </div>
                    <label class="required">Base Price</label>
                    <input type="text" class="form-control" id="baseprice" placeholder="Enter Base Price" onChange={handleSetBasePrice} required/>
                  </div>
                  <div class="form-group store_price_update_btn">
                    <input class="btn btn-primary" onClick={toggleModal} value="Change Store Price" />
                  </div>
                </div>
                {/* <div class="grid grid-3">
                  {priceLevels.map((priceLevel,index) =>(
                        <div class="form-group">
                        <label>{priceLevel.Description}</label>
                        <input type="number"  id={priceLevel.Code} onChange={(e) => handleChange(e, priceLevel.Code)}/>
                    </div>                    
                  ))}
                </div> */}
              </div>
         ):(
          <div class="section section-gray">
                  <h2 className="pricelevel_title">Price Level</h2>
            <div class="grid grid-4">
            {priceLevels.filter(item=> userDetails.storecode.some(item2 => item2.storecode ===item.Code)).map((priceLevel, index) => (
                                  <div class="form-group">
                                    <label>{priceLevel.strname}(#{priceLevel.Description})</label>
                                    <input type="number" className="priceLevel" id={priceLevel.Code} value={priceLevel.value} placeholder="Enter Price"onChange={(e) =>
                                        handleChange(e, priceLevel.Code)
                                      }
                                    />
                                  </div>
                                ))}</div>
          </div>
         )}
              

              <div class="section section-purple">
                <h2>ITEM ATTRIBUTES</h2>
                <div class="grid grid-3">

                <div class="form-group">
                    <label>Gender</label>
                    <select class="form-control" id="gender" onChange={(e) =>setGender(e.target.value)} >
                      <option value="">Select Gender</option>
                      <option value="0">Boy</option>
                      <option value="1">Girl</option>
                      <option value="2">Both</option>
                    </select>
                  </div>

                  <div class="form-group">
                    <label>Low Age</label>
                    <select
                      class="form-control"
                      id="lowage"
                      onChange={(e) => setLowAge(e.target.value)}
                    >
                      <option value="">Select Low Age</option>
                      <option value="0">0</option>
                      <option value="0.5">0.5</option>
                      <option value="1">1</option>
                      <option value="2">2</option>
                      <option value="3">3</option>
                      <option value="4">4</option>
                      <option value="5">5</option>
                      <option value="6">6</option>
                      <option value="7">7</option>
                      <option value="8">8</option>
                      <option value="9">9</option>
                      <option value="10">10</option>
                      <option value="11">11</option>
                      <option value="12">12</option>
                    </select>
                    {/* <input
                      type="text"
                      onChange={(e) => setLowAge(e.target.value)}
                    /> */}
                  </div>
                  
                  <div class="form-group">
                    <label>High Age</label>
                    <select
                      class="form-control"
                      id="highage"
                      onChange={(e)=> setHighAge(e.target.value)}
                    >
                      <option value="">Select High Age</option>
                      <option value="0">0</option>
                      <option value="0.5">0.5</option>
                      <option value="1">1</option>
                      <option value="2">2</option>
                      <option value="3">3</option>
                      <option value="4">4</option>
                      <option value="5">5</option>
                      <option value="6">6</option>
                      <option value="7">7</option>
                      <option value="8">8</option>
                      <option value="9">9</option>
                      <option value="10">10</option>
                      <option value="11">11</option>
                      <option value="12">12</option>
                    </select>
                    {/* <input
                      type="text"
                      onChange={(e) => setHighAge(e.target.value)}
                    /> */}
                  </div>

                  <div class="form-group">
                    <label>Individual Ages</label>
                    {/* <div>{individualAges}</div> */}
                    <input type="text" value={individualAgesString} />
                    {/* <Multiselect
                                      id="individualages"
                                      displayValue="ages"
                                      // ref={multiselectRef}
                                      selectedValues={individualAges}
                                      onKeyPressFn={function noRefCheck() {}}
                                      onRemove={function noRefCheck() {}}
                                      onSearch={function noRefCheck() {}}
                                      // onSelect={handleStoreCode}
                                      options={individualAges}
                                      placeholder="Individual Ages"
                                     
                                    /> */}
                   
                  </div>

                  <div class="form-group">
                    <label>Age Appropriateness</label>
                    <select class="form-control" id="" onChange={(e) =>setAgeAppropriateness(e.target.value)} >
                      <option value="">Select Age Appropriateness</option>
                      <option value="INFANT (0-12MOS)">{capitalizeWords('INFANT (0-12MOS)')}</option>
                      <option value="PRESCHOOL (3-5YRS)">{capitalizeWords('PRESCHOOL (3-5YRS)')}</option>
                      <option value="TODDLER (12-24MOS)">{capitalizeWords('TODDLER (12-24MOS)')}</option>
                      <option value="YOUNG CHILDREN (5-7YRS)">{capitalizeWords('YOUNG CHILDREN (5-7YRS)')}</option>
                      <option value="TWEEN (8-12YRS)">{capitalizeWords('TWEEN (8-12YRS)')}</option>
                      <option value="TEEN (13+YRS)">{capitalizeWords('TEEN (13+YRS)')}</option>
                    </select>
                    
                  </div>

                  <div class="form-group" >
                    <label> Skill Builder</label>
                    {/* <span style={{position:"absolute",top:"50%",left:"3%",zIndex:"10"}}>Select Skill Builder</span> */}
                    {/* <Multiselect
                                      id="skillbuilder"
                                      displayValue="Description"
                                      // ref={multiselectRef}
                                      // selectedValues={individualAges}
                                      onKeyPressFn={function noRefCheck() {}}
                                      onRemove={handleSkillBuilders}
                                      onSelect={handleSkillBuilders}
                                      options={[{Description:"Fine Motor",value:"1"},
                                        {Description:"Gross Motor",value:"2"},
                                        {Description:"Language & Speech",value:"3"},
                                        {Description:"Cognitive",value:"4"},
                                        {Description:"Visual & Spatial Perception",value:"5"},
                                        {Description:"Social Skills & Self-Esteem",value:"6"},
                                        {Description:"Sensory Processing",value:"7"},
                                        {Description:"Oral Motor",value:"8"}
                                      
                                      ]}
                                      placeholder=""
                                      hidePlaceholder={true}
                                      
                                     
                                    /> */}
                                           <Select
      closeMenuOnSelect={false}
      components={animatedComponents}
      isMulti
      onChange={handleSkillBuilders}
      // onRemove={handleStoreCode}
      // value={selectedStoreCode}
      options={[
        {Description: "Fine Motor", value: "1", label: "Fine Motor Skills"},
        {Description: "Gross Motor", value: "2", label: "Gross Motor Skills"},
        {Description: "Language & Speech", value: "3", label: "Language and Speech Development"},
        {Description: "Cognitive", value: "4", label: "Cognitive Development"},
        {Description: "Visual & Spatial Perception", value: "5", label: "Visual & Spatial Perception Skills"},
        {Description: "Social Skills & Self-Esteem", value: "6", label: "Social Skills & Self-Esteem"},
        {Description: "Sensory Processing", value: "7", label: "Sensory Processing Skills"},
        {Description: "Oral Motor", value: "8", label: "Oral Motor Skills"}
      ]} 
      placeholder="Select Skill Builder" 
      className="newselect"
      theme={(theme) => ({
        ...theme,
        colors: {
          ...theme.colors,
          primary25: '#1967d2',
          primary: 'rgb(3 207 217)',
        },
       
      })}
      styles={{
        control: (baseStyles, state) => ({
          ...baseStyles,
          minHeight:'47px'
        }),
        placeholder: (baseStyles, state) => ({
          ...baseStyles,
          color:'black',
          outline:'none'
        }),
        input: (baseStyles, state) => ({
          ...baseStyles,
          outline:'none'
        })
      }
    
    }
      
    />
                  
                  </div>

                  <div class="form-group">
                    <label>Battery Type :</label>

                    <select class="form-control" id="batteryType" onChange={(e) =>setBatteryType(e.target.value)} >
                      <option value="">Select Batteries</option>
                      <option value="9V">9V</option>
                      <option value="AA">AA</option>
                      <option value="AAA">AAA</option>
                      <option value="C">C</option>
                      <option value="D">D</option>
                    </select>

                  </div>

                  <div class="form-group">
                  <div class="switchs">
                  <div class="form-group">
                  <label>Gift Wrap</label>
                    <div className="gift_wrap_checkbox">
                      <label
                        className={`switch3 ${
                          giftWrap ? "switch3-checked" : ""
                        }`}
                      >
                        <input
                          type="checkbox"
                          checked={giftWrap}
                          onChange={(e) => setGiftWrap(e.target.checked)}
                        />
                        <div></div>
                      </label>
                    </div>
                  </div>
                  <div class="form-group">
                    <label>NSO</label>
                    <div className="nso_checkbox">
                      <label className={`switch3 ${nso ? "switch3-checked" : ""}`} >
                        <input
                          type="checkbox"
                          checked={nso}
                          onChange={(e) => setNso(e.target.checked)}
                        />
                        <div></div>
                      </label>
                    </div>
                  </div> 

                  <div class="form-group">
                    <label>LE Exclusive</label>
                    <div className="le_exclusive_checkbox">
                      <label
                        className={`switch3 ${
                          leExclusive ? "switch3-checked" : ""
                        }`}
                      >
                        <input
                          type="checkbox"
                          checked={leExclusive}
                          onChange={(e) => setLEExclusive(e.target.checked)}
                        />
                        <div></div>
                      </label>
                    </div>
                  </div>
                   </div>
                </div>

                <div class="form-group">
                              <div class="form-group">
                                    <label>Choking Hazard</label>
                                    <div className="choking_hazard_checkbox">
                                      <label
                                        className={`switch3 ${
                                          chokingHazard ? "switch3-checked" : ""
                                        }`}
                                      >
                                        <input
                                          type="checkbox"
                                          checked={chokingHazard}
                                          onChange={(e) => setChokingHazard(e.target.checked)}
                                        />
                                        <div></div>
                                      </label>
                                    </div>
                                  </div>
                </div>


                  {/* <div class="form-group">
                    <label>Batteries</label>

                    <div className="batteries_checkbox">
                      <label className={`switch3 ${batteries ? "switch3-checked" : "" }`} >
                        <input type="checkbox" checked={batteries} onChange={(e) => setBatteries(e.target.checked)} />
                        <div></div>
                      </label>
                    </div>
                  </div> */}


                  {/* <div class="form-group">
                    <label>Date Test - Brian + Diego</label>
                    <input type="text" />
                  </div> */}

                  {/* <div class="form-group">
                    <label>Franchise Group Code</label>
                    <input
                      type="text"
                      onChange={(e) => setFranchiseGroupCode(e.target.value)}
                    />
                  </div> */}


                </div>
              </div>

              <div class="section section-gray">
                <h2>LE INFO</h2>
                <div class="grid grid-3">

                <div class="form-group">
                    <label>LE Item Category</label>
                    <select class="form-control" id="itemcategory" onChange={(e) =>setLEItemCategory(e.target.value)} >
                      <option value="">Select LE Item Category</option>
                      <option value="1">{capitalizeWords('ART')}</option>
<option value="2">{capitalizeWords('BOOKS')}</option>
<option value="3">{capitalizeWords('CARDS/STICKERS')}</option>
<option value="4">{capitalizeWords('ACTION/SKILL SPORTS')}</option>
<option value="5">{capitalizeWords('ROOM DECOR')}</option>
<option value="6">{capitalizeWords('GAMES')}</option>
<option value="7">{capitalizeWords('DOLLS')}</option>
<option value="8">{capitalizeWords('INFANT (0-12MOS)')}</option>
<option value="9">{capitalizeWords('CONSTRUCTION')}</option>
<option value="10">{capitalizeWords('MUSIC/CASSETTE/CD')}</option>
<option value="11">{capitalizeWords('PARTY FAVORS')}</option>
<option value="12">{capitalizeWords('PLUSH')}</option>
<option value="13">{capitalizeWords('PRESCHOOL (3-5YRS)')}</option>
<option value="14">{capitalizeWords('SCIENCE')}</option>
<option value="15">{capitalizeWords('TRANSIT')}</option>
<option value="16">{capitalizeWords('PUZZLES')}</option>
<option value="17">{capitalizeWords('WHIZ KIDS')}</option>
<option value="18">{capitalizeWords('TWEEN 7+')}</option>
<option value="19">{capitalizeWords('TEEN 13+')}</option>
<option value="21">{capitalizeWords('CANDY')}</option>
<option value="22">{capitalizeWords('COLLECTABLES')}</option>
<option value="23">{capitalizeWords('BACK TO SCHOOL')}</option>
<option value="24">{capitalizeWords('COMPOUNDS')}</option>
<option value="27">{capitalizeWords('PERSONALIZING')}</option>
<option value="28">{capitalizeWords('DVDs')}</option>
<option value="30">{capitalizeWords('DISPLAYS')}</option>
<option value="31">{capitalizeWords('FLOOR FIXTURES')}</option>
<option value="32">{capitalizeWords('G.O.G')}</option>
<option value="35">{capitalizeWords('SOFTWARE')}</option>
<option value="40">{capitalizeWords('SEASONAL')}</option>
<option value="41">{capitalizeWords('LICENSED SPORTS')}</option>
<option value="42">{capitalizeWords('TRAVEL')}</option>
<option value="43">{capitalizeWords('TODDLER (12-24MOS)')}</option>
<option value="44">{capitalizeWords('TEACHER')}</option>
<option value="55">{capitalizeWords('BIRTHDAY PARTIES')}</option>
<option value="56">{capitalizeWords('REUSABLE BAG')}</option>
<option value="60">{capitalizeWords('GIFTS')}</option>
<option value="90">{capitalizeWords('DONATIONS')}</option>
<option value="91">{capitalizeWords('GIFT CARDS')}</option>
<option value="92">{capitalizeWords('MISCELLANEOUS ITEMS')}</option>
<option value="98">{capitalizeWords('FOOD')}</option>
<option value="99">{capitalizeWords('COUPON')}</option>
<option value="211">{capitalizeWords('HEALTH & SAFETY')}</option>

                  </select>
                 
                  </div>

                  <div class="form-group">
                    <label>LE Current Catalog</label>
                    <select class="form-control"  onChange={(e) =>setLECurrentCatalog(e.target.value)} >
                      <option value="">Select LE Current Catalog</option>
                      <option value="C01">{capitalizeWords('JANUARY CATALOG')}</option>
<option value="C02">{capitalizeWords('FEBRUARY CATALOG')}</option>
<option value="C03">{capitalizeWords('MARCH CATALOG')}</option>
<option value="C04">{capitalizeWords('APRIL CATALOG')}</option>
<option value="C05">{capitalizeWords('MAY CATALOG')}</option>
<option value="C06">{capitalizeWords('JUNE CATALOG')}</option>
<option value="C07">{capitalizeWords('JULY CATALOG')}</option>
<option value="C08">{capitalizeWords('AUGUST CATALOG')}</option>
<option value="C09">{capitalizeWords('SEPTEMBER CATALOG')}</option>
<option value="C10">{capitalizeWords('OCTOBER CATALOG')}</option>
<option value="C11">{capitalizeWords('NOVEMBER CATALOG')}</option>
<option value="C12">{capitalizeWords('DECEMBER CATALOG')}</option>

                    </select>
                    {/* <Multiselect
                                      id="currencatalog"
                                      displayValue="catalog"
                                      // ref={multiselectRef}
                                      selectedValues={(selectedvals)=>setLECurrentCatalog(selectedvals)}
                                      onKeyPressFn={function noRefCheck() {}}
                                      onRemove={function noRefCheck() {}}
                                      onSearch={function noRefCheck() {}}
                                      // onSelect={handleStoreCode}
                                      options={[
                                        { id: "C01", catalog: "JANUARY CATALOG" },
                                        { id: "C02", catalog: "FEBRUARY CATALOG" },
                                        { id: "C03", catalog: "MARCH CATALOG" },
                                        { id: "C04", catalog: "APRIL CATALOG" },
                                        { id: "C05", catalog: "MAY CATALOG" },
                                        { id: "C06", catalog: "JUNE CATALOG" },
                                        { id: "C07", catalog: "JULY CATALOG" },
                                        { id: "C08", catalog: "AUGUST CATALOG" },
                                        { id: "C09", catalog: "SEPTEMBER CATALOG" },
                                        { id: "C10", catalog: "OCTOBER CATALOG" },
                                        { id: "C11", catalog: "NOVEMBER CATALOG" },
                                        { id: "C12", catalog: "DECEMBER CATALOG" }
                                      ]}
                                      placeholder="Select LE Current Catalog"
                                     
                                    /> */}
                    
                  </div>

                  <div class="form-group">
                    <label>LE Catalog Designation</label>
                    {/* <Multiselect
                                      id="catalogdesignation"
                                      displayValue="Catalog Designation"
                                      // ref={multiselectRef}
                                    //  selectedValues={handleDesignation}
                                      onKeyPressFn={function noRefCheck() {}}
                                      onRemove={handleDesignation}
                                      onSearch={function noRefCheck() {}}
                                       onSelect={handleDesignation}
                                       options={[
                                        { ID: 1, "Catalog Designation": "January Catalog" },
                                        { ID: 2, "Catalog Designation": "February Catalog" },
                                        { ID: 3, "Catalog Designation": "March Catalog" },
                                        { ID: 4, "Catalog Designation": "April Catalog" },
                                        { ID: 5, "Catalog Designation": "May Catalog" },
                                        { ID: 6, "Catalog Designation": "June Catalog" },
                                        { ID: 7, "Catalog Designation": "July Catalog" },
                                        { ID: 8, "Catalog Designation": "August Catalog" },
                                        { ID: 9, "Catalog Designation": "September Catalog" },
                                        { ID: 10, "Catalog Designation": "October Catalog" },
                                        { ID: 11, "Catalog Designation": "November Catalog" },
                                        { ID: 12, "Catalog Designation": "December Catalog" }
                                      ]}
                                      
                                     placeholder=""
                                    /> */}
                                    <Select
      closeMenuOnSelect={false}
      components={animatedComponents}
      isMulti
      onChange={handleDesignation}
      // onRemove={handleStoreCode}
      // value={selectedStoreCode}
      options={[
        { ID: 1, "Catalog Designation": "January Catalog", label: "January Catalog", value: 1 },
        { ID: 2, "Catalog Designation": "February Catalog", label: "February Catalog", value: 2 },
        { ID: 3, "Catalog Designation": "March Catalog", label: "March Catalog", value: 3 },
        { ID: 4, "Catalog Designation": "April Catalog", label: "April Catalog", value: 4 },
        { ID: 5, "Catalog Designation": "May Catalog", label: "May Catalog", value: 5 },
        { ID: 6, "Catalog Designation": "June Catalog", label: "June Catalog", value: 6 },
        { ID: 7, "Catalog Designation": "July Catalog", label: "July Catalog", value: 7 },
        { ID: 8, "Catalog Designation": "August Catalog", label: "August Catalog", value: 8 },
        { ID: 9, "Catalog Designation": "September Catalog", label: "September Catalog", value: 9 },
        { ID: 10, "Catalog Designation": "October Catalog", label: "October Catalog", value: 10 },
        { ID: 11, "Catalog Designation": "November Catalog", label: "November Catalog", value: 11 },
        { ID: 12, "Catalog Designation": "December Catalog", label: "December Catalog", value: 12 }
      ]} 
      placeholder="Select LE Catalog Designation" 
      className="newselect"
      theme={(theme) => ({
        ...theme,
        colors: {
          ...theme.colors,
          primary25: '#1967d2',
          primary: 'rgb(3 207 217)',
        },
       
      })}
      styles={{
        control: (baseStyles, state) => ({
          ...baseStyles,
          minHeight:'47px'
        }),
        placeholder: (baseStyles, state) => ({
          ...baseStyles,
          color:'black',
          outline:'none'
        }),
        input: (baseStyles, state) => ({
          ...baseStyles,
          outline:'none'
        })
      }
    
    }
      
    />
                    
                  </div>
                  <div class="form-group">
                    <label class="required">Tax Category</label>
                    <select class="form-control" id="tax" value={taxCategory} onChange={(e) =>setTaxCategory(e.target.value)} required>
                      {taxCategoryOptions.map((taxcategoryValue, index) => (
                        <option value={taxcategoryValue.value}>
                          {taxcategoryValue.label}
                        </option>
                      ))}

                    </select>
                   
                  </div>

                  <div class="form-group" style={{marginTop:"6px"}}>
                    <label>Trend Category</label>
                    <input
                      type="text"
                      onChange={(e) => setTrendCategory(e.target.value)}
                    />
                  </div>

                  {/* <div class="form-group">
                        <label>Classification</label>
                        <select class="form-control" id="store" onChange={selectDept} >
                              <option value="">Select Department</option>
                              <option value="001">ARTS & CRAFTS</option>
                              <option value="002">BOOKS</option>
                              <option value="004">ACTIVE PLAY & SKILL TOYS</option>
                              <option value="006">GAMES & PUZZLES</option>
                              <option value="007">DOLLS</option>
                              <option value="009">CONSTRUCTION & BUILDING</option>
                              <option value="011">IMPULSE</option>
                              <option value="012">PLUSH</option>
                              <option value="013">IMAGINATIVE & PRETEND PLAY</option>
                              <option value="014">SCIENCE</option>
                              <option value="015">TRANSIT</option>
                              <option value="017">TRADING CARDS</option>
                              <option value="018">FASHION</option>
                              <option value="019">DEVELOPMENTAL & EDUCATIONAL</option>
                              <option value="021">FOOD</option>
                              <option value="029">SERVICES</option>
                              <option value="030">SUPPLIES</option>
                              <option value="999">NEON ELEPHANT</option>
                    </select> 
                    </div> */}
 
                  {/* <div class="form-group">
                        <label>Lead Time (days)</label>
                        <input type="number" />
                    </div> */}
                  {/* <div class="form-group">
                    <label>Subclass 1</label>
                    <input type="text" />
                  </div>
                  <div class="form-group">
                    <label>Subclass 2</label>
                    <input type="text" />
                  </div> */}
                  {/* <div class="form-group">
                        <label>Bin Number</label>
                        <input type="text" />
                    </div> */}
                </div>
              </div>


              <div class="section section-orange">
                <h2>WEB INFO SECTION</h2>
                <div class="grid grid-2 web_switchs">
                  <div class="row">
                    <div class="col-sm-2">
                      <div class="switchs">
                      <div class="form-group">
                          <label>Available On Web</label>

                          <div className="choking_hazard_checkbox">
                            <label className={`switch3 ${availableOnWeb ? "switch3-checked" : ""}`}>
                              <input type="checkbox" checked={availableOnWeb} onChange={(e) => setAvailableOnWeb(e.target.checked)} />
                              <div></div>
                            </label>
                          </div>

                  </div>
                      </div>
 

                    </div>
                    <div class="col-sm-10">
                    <div class="form-group">
                    <label>Web Description</label>
                    {/* <RichTextEditor
                      value={webDescription}
                      onChange={setWebDescriptionContent}
                      placeholder="Enter Web Description.."
                    /> */}
                    <input type="text" onChange={(e) => setWebDescriptionContent(e.target.value)} />
                  </div>
                    </div>
                  </div>


                  </div>
                  <div class="grid grid-1">

                  <div class="form-group">
                    <label>Web Short Description</label>
                    <RichTextEditor
                      value={webShortDescription}
                      onChange={setWebShortDescriptionContent}
                      placeholder="Enter Web Short Description.."
                    />

                    {/* <input type="text" onChange={(e) => setWebShortDescription(e.target.value)} /> */}
                  </div>


                  <div class="form-group">
                    <label>Web Long Description</label>
                    <RichTextEditor
                      value={webLongDescription}
                      onChange={setWebLongDescriptionContent}
                      placeholder="Enter Web Long Description.."
                    />

                    {/* <input type="text" onChange={(e) => setWebLongDescription(e.target.value)} /> */}
                  </div>


                  </div>
                  <div class="grid grid-4">
                  <div class="form-group">
                    <label>Metawords</label>
                    <input
                      type="text"
                      onChange={(e) => setMetawords(e.target.value)}
                    />
                  </div>

                  <div class="form-group">
                    <label >Item Interests</label>
                    {/* <Multiselect
                                      id="iteminterest"
                                      displayValue="label"
                                      // ref={multiselectRef}
                                      // selectedValues={individualAges}
                                      onKeyPressFn={function noRefCheck() {}}
                                      onRemove={handleItemInterest}
                                      onSelect={handleItemInterest}
                                      options={[
                                        { "value": "3709", "label": "Infant" },
                                        { "value": "3713", "label": "Party Favors" },
                                        { "value": "3714", "label": "Tween" },
                                        { "value": "3720", "label": "Preschool" },
                                        { "value": "3728", "label": "Toddler" },
                                        { "value": "3751", "label": "Pretend Play" },
                                        { "value": "4093", "label": "Books" },
                                        { "value": "4100", "label": "Science" },
                                        { "value": "4120", "label": "Ride-Ons" },
                                        { "value": "4927", "label": "Health and Safety" },
                                        { "value": "7191", "label": "Best Sellers" },
                                        { "value": "7192", "label": "Stuffed Animals" },
                                        { "value": "7193", "label": "Games" },
                                        { "value": "7194", "label": "Boredom Busters" },
                                        { "value": "7194", "label": "Health & Safety" },
                                        { "value": "7195", "label": "Father's Day" },
                                        { "value": "7196", "label": "Arts & Creativity" },
                                        { "value": "7197", "label": "Construction" },
                                        { "value": "7198", "label": "Collectables" },
                                        { "value": "7199", "label": "Bunny Buffet" },
                                        { "value": "7200", "label": "Summer" },
                                        { "value": "7201", "label": "Dolls" },
                                        { "value": "7203", "label": "Fashion" },
                                        { "value": "7204", "label": "Accessories" },
                                        { "value": "7205", "label": "Room Decor" },
                                        { "value": "7206", "label": "Mother's Day" },
                                        { "value": "7207", "label": "Musical Toys" },
                                        { "value": "7208", "label": "Fidget Toys" },
                                        { "value": "7209", "label": "Travel Toys" },
                                        { "value": "7210", "label": "Educational" },
                                        { "value": "7211", "label": "Puzzles & Brainteasers" },
                                        { "value": "7212", "label": "S.T.E.A.M" },
                                        { "value": "7213", "label": "Valentine's" },
                                        { "value": "7214", "label": "Spring" },
                                        { "value": "7215", "label": "Gadgets" },
                                        { "value": "7216", "label": "Easter" },
                                        { "value": "7217", "label": "Stocking Stuffers" },
                                        { "value": "7218", "label": "Christmas" },
                                        { "value": "7219", "label": "Winter" },
                                        { "value": "7220", "label": "Personalization" },
                                        { "value": "7221", "label": "Halloween" },
                                        { "value": "9946", "label": "Fall" },
                                        { "value": "10329", "label": "None" },
                                        { "value": "11128", "label": "Classic Wood" },
                                        { "value": "13169", "label": "Custom Gift Boxes" },
                                        { "value": "18927", "label": "Gift Cards" },
                                        { "value": "19016", "label": "Action-Skill-Sports" },
                                        { "value": "19024", "label": "Vehicles and Remote Control" },
                                        { "value": "19027", "label": "Lego" },
                                        { "value": "19029", "label": "Candy" },
                                        { "value": "19033", "label": "Chanukkah" },
                                        { "value": "19042", "label": "Squishmallows" }
                                      ]}
                                      
                                      placeholder=""
                                      hidePlaceholder={true}
                                      
                                     
                                    /> */}

<Select
      closeMenuOnSelect={false}
      components={animatedComponents}
      isMulti
      onChange={handleItemInterest}
      // onRemove={handleStoreCode}
      // value={selectedStoreCode}
      options={[
        { "value": "3709", "label": "Infant" },
        { "value": "3713", "label": "Party Favors" },
        { "value": "3714", "label": "Tween" },
        { "value": "3720", "label": "Preschool" },
        { "value": "3728", "label": "Toddler" },
        { "value": "3751", "label": "Pretend Play" },
        { "value": "4093", "label": "Books" },
        { "value": "4100", "label": "Science" },
        { "value": "4120", "label": "Ride-Ons" },
        { "value": "4927", "label": "Health and Safety" },
        { "value": "7191", "label": "Best Sellers" },
        { "value": "7192", "label": "Stuffed Animals" },
        { "value": "7193", "label": "Games" },
        { "value": "7194", "label": "Boredom Busters" },
        { "value": "7194", "label": "Health & Safety" },
        { "value": "7195", "label": "Father's Day" },
        { "value": "7196", "label": "Arts & Creativity" },
        { "value": "7197", "label": "Construction" },
        { "value": "7198", "label": "Collectables" },
        { "value": "7199", "label": "Bunny Buffet" },
        { "value": "7200", "label": "Summer" },
        { "value": "7201", "label": "Dolls" },
        { "value": "7203", "label": "Fashion" },
        { "value": "7204", "label": "Accessories" },
        { "value": "7205", "label": "Room Decor" },
        { "value": "7206", "label": "Mother's Day" },
        { "value": "7207", "label": "Musical Toys" },
        { "value": "7208", "label": "Fidget Toys" },
        { "value": "7209", "label": "Travel Toys" },
        { "value": "7210", "label": "Educational" },
        { "value": "7211", "label": "Puzzles & Brainteasers" },
        { "value": "7212", "label": "S.T.E.A.M" },
        { "value": "7213", "label": "Valentine's" },
        { "value": "7214", "label": "Spring" },
        { "value": "7215", "label": "Gadgets" },
        { "value": "7216", "label": "Easter" },
        { "value": "7217", "label": "Stocking Stuffers" },
        { "value": "7218", "label": "Christmas" },
        { "value": "7219", "label": "Winter" },
        { "value": "7220", "label": "Personalization" },
        { "value": "7221", "label": "Halloween" },
        { "value": "9946", "label": "Fall" },
        { "value": "10329", "label": "None" },
        { "value": "11128", "label": "Classic Wood" },
        { "value": "13169", "label": "Custom Gift Boxes" },
        { "value": "18927", "label": "Gift Cards" },
        { "value": "19016", "label": "Action-Skill-Sports" },
        { "value": "19024", "label": "Vehicles and Remote Control" },
        { "value": "19027", "label": "Lego" },
        { "value": "19029", "label": "Candy" },
        { "value": "19033", "label": "Chanukkah" },
        { "value": "19042", "label": "Squishmallows" }
      ]} 
      placeholder="Select Item Interests" 
      className="newselect"
      theme={(theme) => ({
        ...theme,
        colors: {
          ...theme.colors,
          primary25: '#1967d2',
          primary: 'rgb(3 207 217)',
        },
       
      })}
      styles={{
        control: (baseStyles, state) => ({
          ...baseStyles,
          minHeight:'47px'
        }),
        placeholder: (baseStyles, state) => ({
          ...baseStyles,
          color:'black',
          outline:'none'
        }),
        input: (baseStyles, state) => ({
          ...baseStyles,
          outline:'none'
        })
      }
    
    }
      
    />
                    
                    
                  </div>

                  <div class="form-group">
                    <label>Shipping Type</label>
                    <select
                      class="form-control"
                      id="type"
                      onChange={(e) => setShippingType(e.target.value)}
                    >
                      <option value=""></option>
                      <option value="Small">Small</option>
                      <option value="Regular">Regular</option>
                      <option value="Large">Large</option>
                      <option value="XL">XL</option>
                      <option value="XXL">XXL</option>
                      <option value="XXXL">XXXL</option>
                    </select>
                  </div>

                  <div class="form-group">
                    <label>Extra Shipping Charge</label>
                    <div className="extra_shipping_charge_checkbox">
                      <label
                        className={`switch3 ${
                          extraShippingCharge ? "switch3-checked" : ""
                        }`}
                      >
                        <input
                          type="checkbox"
                          checked={extraShippingCharge}
                          onChange={(e) =>
                            setExtraShippingCharge(e.target.checked)
                          }
                        />
                        <div></div>
                      </label>
                    </div>
                  </div>

                </div>
                <div class="grid grid-4">
                <div class="form-group">
                <label>Image 1</label>
                {/* <ImageUpload id="1" image={image1} onImageChange={(file) => setImage1(file)} /> */}
                <input type="file" class="form-control" accept="image/*" />
                  </div>
                  <div class="form-group">
                <label>Image 2</label>
                <input type="file" class="form-control" accept="image/*" />
                {/* <ImageUpload id="2" image={image2} onImageChange={(file) => setImage2(file)} /> */}
                  </div>
                  <div class="form-group">
                <label>Image 3</label>
                <input type="file" class="form-control" accept="image/*" />
                {/* <ImageUpload  id="3" image={image3} onImageChange={(file) => setImage3(file)} /> */}
                  </div>
                  <div class="form-group">
                        <label>Video URL</label>
                        <input type="text"   onChange={(e)=>setVideoUrl(e.target.value)}/>
                      </div>               
                  </div>
                  <div class="grid grid-2">


                  </div>

               </div>
               {userDetails.usertype.trim() ==="CORP" ? (
                <div class="section section-purple">
                <h2 >Additional Information</h2>
                <div class="grid grid-3">
                { userDetails.usertype.trim() ==="CORP" ? (
                   <div class="form-group">
                   <label>Item Status</label>
                   <select class="form-control" id="type" onChange={(e) => setStatus(e.target.value)} >
                     <option value=""></option>
                     <option value="Approved">Approved</option>
                     <option value="In Review">In Review</option>
                     <option value="Pending Review">Pending Review</option>
                     <option value="Rejected">Rejected</option>
                   </select>
                 </div>
                ):(null)}
                 

                <div class="form-group">
                    <label>Reason</label>
                    <input
                      type="text"
                      onChange={(e) => setReason(e.target.value)}
                    />
                  </div>

                    {/* <div class="form-group">
                        <label>Weight (kg)</label>
                        <input type="number" step="0.01" />
                    </div>
                    <div class="form-group">
                        <label>Dimensions</label>
                        <input type="text" placeholder="L x W x H" />
                    </div>
                    <div class="form-group">
                        <label>Notes</label>
                        <textarea rows="3"></textarea>
                    </div> */}
                </div>
            </div>
               ):(null)}
              
            </form>
            <div class="addnewCatalogbtn">
            <div class="btn-group">
                {/* <button class="btn btn-outline">Clear Form</button> */}
                <button class="btn btn-primary" onClick={newCatalog}>
                  SAVE CHANGES
                </button>
              </div>
            </div>

          </div>
        </div>
      </div>
    </>
  );
}